import { render, staticRenderFns } from "./merchant-add.vue?vue&type=template&id=60e943a2&scoped=true&"
import script from "./merchant-add.vue?vue&type=script&lang=js&"
export * from "./merchant-add.vue?vue&type=script&lang=js&"
import style0 from "./merchant-add.vue?vue&type=style&index=0&id=60e943a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e943a2",
  null
  
)

export default component.exports